import { render } from "./np-tree-menu.vue?vue&type=template&id=b25bfea8&scoped=true"
import script from "./np-tree-menu.vue?vue&type=script&lang=js"
export * from "./np-tree-menu.vue?vue&type=script&lang=js"

import "./np-tree-menu.vue?vue&type=style&index=0&id=b25bfea8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b25bfea8"]])

export default __exports__